import axios from 'axios';

export const isValidRetailerNumber = async (retailerId, jurisdiction) => {
  // validate the retailerId by hitting the backend.
  // if the backend returns a 200 status, then the retailerId is valid. If it returns a 400 or 500 status, then the retailerId is invalid.
  const response = await axios.post(
        process.env.REACT_APP_ENDPOINT_RSS_RETAILER_LOOKUP,
        {
          agentNumber: retailerId,
          jurisdiction: jurisdiction,
        },
      );

    return response.data ? true : false;
};